import { createSlice } from '@reduxjs/toolkit'
const initialState = {
    template:null,
    templateid:null,
  }

  export const templateSlice=createSlice({
     name:'template',
     initialState,
     reducers:{
        setTemplate:(state, action)=>{
           state.template=action.payload
        },
        setTemplateId:(state, action)=>{
         state.templateid=action.payload
      },
        
     }
  })
  export const {setTemplate,setTemplateId}=templateSlice.actions;
  export default templateSlice.reducer